import { useEffect, useState } from 'react'
import { Button, Sheet } from '@/design-system'
import { WHATS_NEW, hasSeenWhatsNew, markWhatsNewSeen } from './whatsnew'
import { meow } from './meow'
import './whatsnew.css'

/**
 * The release notes as a sheet: jelly stickers per section, the short lines,
 * the version's name, one button. (Álvaro: diseño B con los textos de C)
 */
export function WhatsNewSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Sheet open={open} onClose={onClose}>
      <div className="wn">
        <span className="wn__kicker">{WHATS_NEW.kicker}</span>
        <h2 className="wn__title">{WHATS_NEW.title}</h2>
        <span className="wn__version">
          Versión {WHATS_NEW.number} · «{WHATS_NEW.name}» · {WHATS_NEW.date}
        </span>
        <div className="wn__stickers" aria-hidden="true">
          {WHATS_NEW.items.map((item) => (
            <span key={item.text} className={'wn__disc wn__disc--' + item.jelly}>
              {item.emoji}
            </span>
          ))}
        </div>
        <ul className="wn__list">
          {WHATS_NEW.items.map((item) => (
            <li key={item.text}>
              <span className="wn__emoji" aria-hidden="true">
                {item.emoji}
              </span>
              {item.text}
            </li>
          ))}
        </ul>
        <Button block size="lg" onClick={onClose}>
          {WHATS_NEW.cta}
        </Button>
      </div>
    </Sheet>
  )
}

/**
 * Greets a person the first time they open the app after an update. A kitten
 * meows when the sheet slides up (or on the first tap, where browsers insist).
 */
export function WhatsNewGate() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (hasSeenWhatsNew()) return
    // Let Home paint first; the sheet is the second thing they see.
    const timer = setTimeout(() => {
      setOpen(true)
      meow()
    }, 700)
    return () => clearTimeout(timer)
  }, [])

  const dismiss = () => {
    markWhatsNewSeen()
    setOpen(false)
  }

  return <WhatsNewSheet open={open} onClose={dismiss} />
}
